import styles from '@/features/common/components/Overview/parts/ProductItem/styles'
import Collapsible from '@/features/ui/components/Collapsible'
import { FC, ReactNode } from 'react'
import { View } from 'react-native'

interface ActionAreaProps {
    expanded: boolean
    TailComponent: ReactNode
    testID?: string
}

const ActionArea: FC<ActionAreaProps> = ({ expanded, TailComponent, testID }) => {
    return (
        <Collapsible open={expanded} containerStyle={styles.actionsContainer} testID={testID}>
            <View style={styles.actionsContent}>{TailComponent}</View>
        </Collapsible>
    )
}

export default ActionArea
